import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-column">
              <h3>Voters Deserve More</h3>
              <p>Working to transform American democracy through proportional electoral reforms.</p>
              <div className="social-icons">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                  </svg>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                  </svg>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
              </div>
            </div>
            <div className="footer-column">
              <h3>Learn More</h3>
              <ul>
                <li><Link to="/faq">FAQs</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/demands">Our Reforms</Link></li>
                <li><Link to="/rank-the-blank">Rank The Blank</Link></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3>Get Involved</h3>
              <ul>
                <li><Link to="/media">Media</Link></li>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/get-involved">Get Involved</Link></li>
                <li><Link to="/simulator">Voting Simulator</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Voters Deserve More. All rights reserved.</p>
          </div>
        </div>
      </footer>

      <style jsx>{`
        .footer {
          background-color: var(--dark, #1a1e41);
          color: white;
          padding: 4rem 0 2rem;
        }

        .container {
          width: 90%;
          max-width: 1200px;
          margin: 0 auto;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 2rem;
          margin-bottom: 3rem;
        }

        .footer-column h3 {
          font-size: 1.2rem;
          margin-bottom: 1.5rem;
          color: var(--tertiary, #A9B5DF);
        }

        .footer-column p {
          margin-bottom: 1.5rem;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.8);
        }

        .footer-column ul {
          list-style-type: none;
          padding: 0;
          margin: 0;
        }

        .footer-column ul li {
          margin-bottom: 0.75rem;
        }

        .footer-column ul li a {
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
          transition: color 0.3s;
        }

        .footer-column ul li a:hover {
          color: white;
        }

        .social-icons {
          display: flex;
          gap: 1rem;
          margin-top: 1rem;
        }

        .social-icons a {
          background-color: rgba(255, 255, 255, 0.1);
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.3s;
        }

        .social-icons a:hover {
          background-color: rgba(255, 255, 255, 0.2);
        }

        .footer-bottom {
          text-align: center;
          padding-top: 2rem;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.9rem;
        }

        address {
          font-style: normal;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.7);
        }

        @media (max-width: 768px) {
          .footer {
            padding: 3rem 0 1.5rem;
          }
          
          .footer-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 2rem 1rem;
          }
        }

        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 2rem;
          }
          
          .footer-column {
            padding-bottom: 1rem;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
          
          .footer-column:last-child {
            border-bottom: none;
          }
          
          .social-icons {
            justify-content: center;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;